<template>
  <section class="mobile_wrap">
    <div>
      레시피 메인
    </div>
  </section>
</template>

<script>
import client from "../client/client";
import Loading from "../components/Loading";
import { useRoute } from 'vue-router'

export default {
  name: "RecipeIntroduce",
  components: {
    Loading,
  },
  data: function () {
    const route = useRoute()
    const { query } = route;
    return {
      loading: true,
      query: query,
    };
  },
  methods: {
    async update() {
      this.loading = false;
      const route = useRoute()
      const { query } = route;
      client.updateToken(query);
    }
  },
  async mounted() {
    this.update();
    window.location.href = `https://0njourney.com/html/Recipe/indexNov.html`;
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/icon.scss";
.mt12{
  margin-top:12px !important;
}
body {
  background-color: #eee !important;
}
.mobile_wrap {
  max-width: 640px;
  width: 100%;
  margin: 0 auto;
  background: #fff;
  box-shadow: 0px 1px 10px rgba(0, 0, 0, 0.1);
  padding-bottom:82px;
  > div {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  }
}
</style>
